import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _get from "lodash/fp/get";
/** @jsx jsx */

import React from 'react';
import { jsx } from 'theme-ui';
import { Link } from 'gatsby';
import { useDocs, useCurrentDoc } from 'docz';
import * as styles from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";

var getHeadings = function getHeadings(route, docs) {
  var doc = docs.find(function (doc) {
    return doc.route === route;
  });

  var headings = _get('headings', doc);

  return headings ? headings.filter(function (heading) {
    return heading.depth === 2;
  }) : [];
};

var getCurrentHash = function getCurrentHash() {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location ? decodeURI(window.location.hash) : '';
};

export var NavLink = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var item = _ref.item,
      props = _objectWithoutPropertiesLoose(_ref, ["item"]);

  var docs = useDocs();
  var current = useCurrentDoc();

  if (item.hidden) {
    return null;
  }

  var to = item.route;
  var headings = docs && getHeadings(to, docs);
  var isCurrent = item.route === current.route;
  var showHeadings = isCurrent && headings && headings.length > 0;
  var currentHash = getCurrentHash();
  return jsx(React.Fragment, null, jsx(Link, _extends({}, props, {
    to: to,
    sx: styles.link,
    activeClassName: "active",
    ref: ref
  })), showHeadings && headings.map(function (heading) {
    return jsx(Link, {
      key: heading.slug,
      to: to + "#" + heading.slug,
      sx: styles.smallLink,
      className: currentHash === "#" + heading.slug ? 'active' : ''
    }, heading.value);
  }));
});

if (typeof NavLink !== 'undefined' && NavLink && NavLink === Object(NavLink) && Object.isExtensible(NavLink) && !NavLink.hasOwnProperty('__filemeta')) {
  Object.defineProperty(NavLink, '__filemeta', {
    configurable: true,
    value: {
      name: "NavLink",
      filename: "node_modules/gatsby-theme-docz/src/components/NavLink/index.js"
    }
  });
}